import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import ModalSection from '../ModalSection';
import PromptModel from '../../../../models/PromptModel';
import { SIDEBAR_ACTIONS } from '../../../../../constants/actionsConstants';
import RightModalLayout from '../../../../layouts/Modal/RightModalLayout';
import QuillComponent from '../QuillComponent';

const Restrictions = ({ agentId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ChatbotIA');

  const [restrictions, setRestrictions] = useState('');
  const [promptId, setPromptId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (agentId) {
      loadRestrictionsContent();
    }
  }, [agentId]);

  const toggleRestrictionsModal = () => {
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  };

  const loadRestrictionsContent = () => {
    if (!agentId) {
      showtoast(t('config.error_loading'));
      setLoading(false);
      return;
    }

    setLoading(true);
    PromptModel.get(agentId, { type: 'restrictions' })
      .then((response) => {
        const prompts = response.data || [];
        const restrictionsPrompt = prompts.find(p => p.type === 'restrictions');

        if (restrictionsPrompt) {
          setRestrictions(restrictionsPrompt.prompt || '');
          setPromptId(restrictionsPrompt.id);
        } else {
          setRestrictions('');
          setPromptId(null);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        showtoast(err.error || t('config.error_loading'));
      });
  };

  const updateInfo = (value) => {
    setRestrictions(value);
  };

  const onSubmit = () => {
    if (!agentId) {
      showtoast(t('config.error_loading'));
      return;
    }

    const params = promptId
      ? { prompt: restrictions }
      : { type: 'restrictions', prompt: restrictions };

    setSaving(true);

    const savePromise = promptId
      ? PromptModel.update(agentId, promptId, params)
      : PromptModel.save(agentId, params);

    savePromise
      .then((result) => {
        if (!promptId && result?.id) {
          setPromptId(result.id);
        }
        setTimeout(() => {
          showtoast(t('config.save_success'));
          setSaving(false);
          toggleRestrictionsModal();
        }, 1000);
      })
      .catch((error) => {
        setSaving(false);
        showtoast(error.message || t('config.save_error'));
      });
  };

  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={t('config.restrictions.modal_title')}
        submitAction={onSubmit}
        submitLabel={t('guides.sidebar_create.update')}
        submitDisabled={saving || loading}
      >
        <ModalSection
          title={t('config.restrictions.section_1_title')}
          description={t('config.restrictions.section_1_description')}
          afterContent={(
            loading ? (
              <div className="tw-flex tw-justify-center tw-items-center tw-py-8">
                <div className="tw-text-gray-500">{t('config.loading')}</div>
              </div>
            ) : (
              <QuillComponent
                name="restrictions"
                value={restrictions || ''}
                onChange={(value) => { updateInfo(value); }}
                overflowHidden={false}
              />
            )
          )}
        />
      </RightModalLayout>
    </div>
  );
};

export default Restrictions;
